import { User } from '@/lib/client-auth';

export interface WorkspaceEntitlements {
  screens: string[];
  features: string[];
}

export interface UserAuthState {
  isLoaded?: boolean;
  isSignedIn?: boolean;
  user?: User;
  entitlementsByWorkspace: Record<string, WorkspaceEntitlements>;
  activeEntitlementWorkspaceKey?: string;
  isEntitlementsLoading: boolean;
}

export const initialAuthState: UserAuthState = {
  entitlementsByWorkspace: {},
  isEntitlementsLoading: false,
};
